<template>
<section>
  <ul id="slide-out" class="sidenav sidenav-fixed z-depth-3" v-if="signedIn">
    <li class="logo-wrapper">
      <img src="./assets/logo.png" class="logo" />
    </li>
    <li>
      <router-link to="/" v-if="$store.claims.languages & 1">
        <i class="material-icons">language</i>
        Languages
      </router-link>
    </li>
    <li>
      <router-link to="/translator" v-if="$store.preferredLanguage && $store.claims.phrases & 1">
        <i class="material-icons">g_translate</i>
        Translate
      </router-link>
    </li>
    <li>
      <router-link to="translatetree" v-if="$store.preferredLanguage && $store.claims.dialogs & 1">
        <i class="material-icons">comment</i>
        Translate Tree
      </router-link>
    </li>
    <li>
      <router-link to="phrases" v-if="$store.preferredLanguage && $store.claims.phrases & 1">
        <i class="material-icons">text_format</i>
        Phrases
      </router-link>
    </li>
    <li>
      <router-link to="dialogs" v-if="$store.preferredLanguage && $store.claims.dialogs & 1">
        <i class="material-icons">speaker_notes</i>
        Dialog Tree
      </router-link>
    </li>
    <li>
      <router-link to="devices" v-if="$store.preferredLanguage && $store.claims.languages & 4">
        <i class="material-icons">device_hub</i>
        Devices
      </router-link>
    </li>
    <li>
      <router-link to="settings" v-if="$store.claims.settings & 1">
        <i class="material-icons">settings</i>
        Settings
      </router-link>
    </li>
    <li>
      <router-link to="users" v-if="$store.claims.users & 1">
        <i class="material-icons">supervisor_account</i>
        Users
      </router-link>
    </li>
    <li>
      <a href="/">
        <i class="material-icons">lock</i>
        Sign out
      </a>
    </li>
      <li class="language-selector">
        Preferred language
        <LanguageSelector/>
    </li>
  </ul>

  <nav class="hide-on-large-only" v-if="signedIn">
    <div class="nav-wrapper helen-blue">
      <ul>
        <li>
          <a href="#" data-target="slide-out" class="sidenav-trigger">
            <i class="material-icons white-text">menu</i>
          </a>
        </li>
      </ul>
      Helen Console
    </div>
  </nav>
  <section class="content" v-if="signedIn">
    <transition name="fade">
    <router-view/>
    </transition>
  </section>
  <div id="signInView" v-if="!signedIn" class="valign-wrapper">
    <div class="card white">  
        <div class="load valign-wrapper white">
          <div class="preloader-wrapper active">
            <div class="spinner-layer spinner-red-only">
              <div class="circle-clipper left">
                <div class="circle"></div>
              </div><div class="gap-patch">
                <div class="circle"></div>
              </div><div class="circle-clipper right">
                <div class="circle"></div>
              </div>
            </div>
          </div>
        </div>   
        <form v-on:submit.prevent="signIn()" class="form">
          <div class="center-logo">
            <img src="./assets/logo.png" class="full-width" />
          </div>
          <div class="row">
            <div class="input-field col s12">
              <input id="username" type="text" v-model="username" >
              <label for="username">Username</label>
            </div>
            <div class="input-field col s12">
              <input id="password" type="password" v-model="password" >
              <label for="password">Password</label>
            </div>
          </div>
          <input type="submit" class="btn-flat right" value="Sign in">
        </form>
    </div>
  </div>
  <div id="welcome" class="modal">
    <div class="modal-content">
      <h4>Welcome to Helen!</h4>
      <p>
        This is your first time sigining in as user <i>admin</i> which is the default user for Helen.<br>
        A new password has been generated for <i>admin</i> to keep your Helen instance safe from intruders.<br><br>
        <b>Your new password is</b>
        <pre>{{ generatedPassword }}</pre>
      </p>
    </div>
    <div class="modal-footer">
      <a href="#!" class="modal-action modal-close waves-effect waves-green btn-flat" @click="generatedPassword = ''">I have saved my password</a>
    </div>
    </div>
</section>
</template>
<script>
  import M from 'materialize-css'
  import LanguageSelector from './components/LanguageSelector.vue'

  export default {
    mounted(){
      if(this.signedIn){
        M.Sidenav.init(this.$el.querySelector('.sidenav'), {});
      }else{
        this.$el.querySelector("#username").focus();
      }
      this.$el.querySelectorAll(".modal").forEach(e => M.Modal.init(e, {}));

      var elems = document.querySelectorAll('.collapsible');
      var options = {
        accordion: true,
      }
      var instances = M.Collapsible.init(elems,options);

       var elems = document.querySelectorAll('select');
       var instances = M.FormSelect.init(elems, {});
    },
    updated(){
       this.$nextTick(function(){
        var elems = document.querySelectorAll('.collapsible');
      var options = {
        accordion:true
      }
      var instances = M.Collapsible.init(elems,options);
      });
    },
    data(){
      return{
        signedIn: false,
        username: "",
        password: "",
        generatedPassword: "",
      }
    },
    methods: {
      signIn() {
        this.$el.querySelector("#signInView .load").style.visibility = "visible";
        this.$el.querySelector("#signInView .form").style.visibility = "hidden";
        this.$http.post('/auth/login', { username: this.username, password: this.password}).then(r => {
          if("generatedPassword" in r.data || r.data.generatedPassword !== undefined){
            this.generatedPassword = r.data.generatedPassword
            M.Modal.getInstance(this.$el.querySelector("#welcome")).open();
          }
          this.signedIn = true;
          this.$store.claims = r.data.user.claims;
          this.$store.token = r.data.token;
          window.axios.defaults.headers.common['token'] = r.data.token;
        }).catch((r) => {
          M.toast({html:"Failed to sign in!"})
          this.$el.querySelector("#signInView .load").style.visibility = "hidden";
          this.$el.querySelector("#signInView .form").style.visibility = "visible";
          this.password = "";
          this.$el.querySelector("#password").focus();
        });
      }
    },
    components:{
      LanguageSelector
    }
  }
</script>
<style scoped>
#signInView{
  height: 100vh;
}
#signInView .card{
  margin:auto;
  padding: 30px;
  width: 500px;
}
#signInView .preloader-wrapper{
  margin: auto;
}
.center-logo{
  margin:auto;
  width: 30%;
  padding-bottom: 30px;
}
.full-width{
  width: 100%;
}
#signInView .load{
  height: 100%;
  position: absolute;
  visibility: hidden;
  z-index: 999999;
  width: 100%;
  top:0;
  left:0;
}
@media only screen and (max-width: 992px) {
  #signInView .card{
    width: 100%;
    margin:20px;
  }
}
.content {
  padding-left: 300px;
  padding-bottom: 0px;
  margin-bottom: 0px;
}
.logo{
  margin: auto;
  width: 40%;
  margin: 10%;
}
.logo-wrapper {
  text-align: center;
  border-bottom: solid 1px lightgray;
  margin-bottom: 10px;
}
@media only screen and (max-width: 992px) {
  .content {
    padding-left: 10px;
    padding-right: 10px;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition-property: opacity;
  transition-duration: 0.25s;
}

.fade-enter-active {
  transition-delay: 0.25s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.language-selector{
    padding: 0px 30px 20px;
    width: 299px;
    border-bottom: solid 1px #dbdbdb;
    border-top: solid 1px #dbdbdb;
    margin-top: 1em;
}
</style>



// WEBPACK FOOTER //
// src/App.vue